import { useState } from 'react';
import { Label, Error, Icon, ClassHelper, useTranslation } from 'components/lib';
import Style from './input.tailwind.js';

export function UserNameInput(props) {

  const { t } = useTranslation();
  const [error, setError] = useState(props.errorMessage || t('global.form.userName.error.unentered'))

  function validate(e) {

    let value = e ? e.target.value : '';
    let valid = undefined;

    // input is required and value is blank
    if (props.required && value === '')
      valid = false;

    // input isn't required and value is blank
    if (!props.required && value === '')
      valid = true;

    if (props.required && value !== '')
      valid = true;

    if (!props.required)
      valid = true;

    // complexity rules
    if (props.validUserName) {
      // Check if username is blank
      if (value.trim() === '') {
        valid = false;
        setError(t('global.form.userName.error.blank'));
      }
      // Check for username length
      else if (value.trim().length < 3 || value.trim().length > 32) {
        valid = false;
        setError(t('global.form.userName.error.min_max', { min: 3, max: 32 }));
      }
      // Check if username contains spaces in the middle
      else if (/\s/.test(value)) {
        valid = false;
        setError(t('global.form.userName.error.space'));
      }
      // Check for username
      else if (/[^a-zA-Z0-9_]/.test(value)) {
        valid = false;
        setError(t('global.form.userName.error.onlyContains'));
      }
    }



    // update the parent form
    props.onChange?.(props.name, value, valid);

  }

  // style
  const userNameStyle = ClassHelper(Style, {

    textbox: true,
    className: props.className,
    error: props.valid === false,
    success: props.valid === true,
    warning: props.warning

  });

  return (
    <div className={Style.input}>

      {props.label &&
        <Label
          text={props.label}
          required={props.required}
          for={props.name}
        />}

      <input
        type='username'
        id={props.for}
        name={props.name}
        value={props.value || ''}
        className={userNameStyle}
        onChange={e => props.onChange?.(props.name, e.target.value, undefined)}
        onBlur={e => validate(e)}
      />

      {props.valid === false &&
        <Error message={error} />}

      {props.valid === true &&
        <Icon
          image='check'
          color='#8CC57D'
          className={Style.successIcon}
          size={16}
        />}

    </div>
  );
}
